import { ViewBookingLayout } from '@view/view_booking/components/view_booking_layout';
import { BookingProvider } from './hooks/use_booking';
import { BookingBasketProvider } from './hooks/use_booking_basket';

export const ViewBooking = () => {
	return (
		<BookingBasketProvider>
			<BookingProvider>
				<ViewBookingLayout />
			</BookingProvider>
		</BookingBasketProvider>
	);
};
